import React from 'react';
import { TrendingUp, Search, Brain, Clock, Target, Zap } from 'lucide-react';

export function Benefits() {
  const benefits = [
    {
      icon: <TrendingUp />,
      title: "Higher Click-Through Rates",
      description: "Create headlines that capture attention and drive more clicks"
    },
    {
      icon: <Search />,
      title: "SEO Optimization",
      description: "Generate titles optimized for search engine rankings"
    },
    {
      icon: <Brain />,
      title: "AI-Powered Intelligence",
      description: "Leverage advanced AI to create compelling headlines"
    },
    {
      icon: <Clock />,
      title: "Save Time",
      description: "Generate multiple headline variations in seconds"
    },
    {
      icon: <Target />,
      title: "Audience Targeting",
      description: "Tailor headlines to your specific audience and industry"
    },
    {
      icon: <Zap />,
      title: "Instant Results",
      description: "Get immediate access to professionally crafted headlines"
    }
  ];

  return (
    <section id="benefits" className="scroll-mt-16">
      <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Why Choose Our Blog Title Generator</h2>
      <div className="grid md:grid-cols-3 gap-8">
        {benefits.map((benefit, index) => (
          <div key={index} className="bg-white rounded-xl shadow-lg p-6">
            <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
              {React.cloneElement(benefit.icon, { className: "w-6 h-6 text-indigo-600" })}
            </div>
            <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
            <p className="text-gray-600">{benefit.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}